import { request } from "./request";
import { phpRequest } from "./phpRequest";
import localforage from "localforage";

export const updateNotificationAPI = notificationIdsArr => {
  return request.post("/platform/v3/notifications/update", {
    ids: notificationIdsArr
  });
};

export function getNotificationListAPI(take, recordId, type) {
  return request.get("/platform/v3/notifications", {
    take,
    recordId,
    type
  });
}

export const getNotificationList = async (take = 15, type = 1) => {
  let companyId = await localforage.getItem("companyId");
  let userData = await localforage.getItem("user");

  const notificationListObjArr = await getNotificationListAPI(
    take,
    [companyId, userData.id],
    type
  );
  if (notificationListObjArr) {
    const checkHasNewNotification =
      notificationListObjArr.notifications?.filter(
        notification => notification.read_at === null
      );
    return {
      notificationListObjArr: notificationListObjArr.notifications || [],
      checkHasNewNotification: checkHasNewNotification || []
    };
  }
};

export function getAnnouncementList(params) {
  return request.post("/platform/v3/announcement_list", params);
}

export function getAnnouncementInfo(params) {
  return request.post("/platform/v3/announcement_info", params);
}

export function deleteAnnouncement(id) {
  return request.post("/platform/v3/delete_announcement", { id });
}

export function createAnnouncement(params) {
  return request.post("/platform/v3/create_announcement", params);
}

export function updateAnnouncement(params) {
  return request.post("/platform/v3/update_announcement", params);
}

export function downloadFileLink(path) {
  return phpRequest.get("/download-file-link", { path });
}

export const handleS3pathDownload = path => {
  downloadFileLink(path).then(fileRes => {
    window.open(fileRes.download_link);
  });
};
